// export const API_URL = 'https://api.belihuloyatrails.com';
export const API_URL = 'https://belihuloya-api.mydemoview.info';
// export const API_URL = 'http://127.0.0.1:8000';
export const API_CLIENT_ID = '2';
export const API_CLIENT_SECRET = 'swyeJtqdAq1CGxU2FdUsBmCbaSUzApUxYojiKnd3';
export const API_GRANT_TYPE = 'password';